import { useId } from 'react';
import { lowerChoiceLabels, type LowerChoice, type LowerOutcome } from '@/lib/lowerItemTotal';

/**
 * The required "which do you mean" question when a line bills less than its item (Christa, feedback 9725dd36).
 * Nothing is preselected; the caller keeps Save disabled until one is chosen.
 */
export function LowerItemTotalChoice({
  lineAmount,
  outcome,
  value,
  onChange,
  note,
  testIdPrefix = 'lower-item-total',
}: {
  lineAmount: number;
  outcome: LowerOutcome;
  value: LowerChoice | null;
  onChange: (choice: LowerChoice) => void;
  note?: string | null;
  testIdPrefix?: string;
}) {
  const name = useId();
  const labels = lowerChoiceLabels(lineAmount, outcome);
  const options: LowerChoice[] = ['lower', 'keep'];
  return (
    <fieldset className="text-xs text-left space-y-1 max-w-[16rem] ml-auto" data-testid={`${testIdPrefix}-option`}>
      <legend className="font-medium text-foreground mb-1">This line is less than the item. Which do you mean?</legend>
      {options.map((option) => (
        <label key={option} className="flex items-start gap-2 cursor-pointer">
          <input
            type="radio"
            name={name}
            value={option}
            checked={value === option}
            onChange={() => onChange(option)}
            className="mt-0.5"
            data-testid={`${testIdPrefix}-${option}`}
          />
          <span>{labels[option]}</span>
        </label>
      ))}
      {note && (
        <p className="text-muted-foreground" data-testid={`${testIdPrefix}-note`}>
          {note}
        </p>
      )}
      {value === null && (
        <p className="text-muted-foreground" data-testid={`${testIdPrefix}-required`}>
          Choose one to save.
        </p>
      )}
    </fieldset>
  );
}
